var React = require('react');

function ArrowCircleUp40x40 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=40, Inverted=off, State=Default","stroke":"currentColor","strokeWidth":"2"},[React.createElement("g",{"id":"Icon/Arrow-reg","key":0},[React.createElement("path",{"id":"Vector","d":"M25 20l-4.5-5h-1L15 20","strokeMiterlimit":"10","strokeLinecap":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M20 26V15","strokeLinejoin":"bevel","key":1})]),React.createElement("rect",{"x":"1","y":"1","width":"38","height":"38","rx":"19","key":1})]));
}

ArrowCircleUp40x40.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = ArrowCircleUp40x40;

ArrowCircleUp40x40.default = ArrowCircleUp40x40;
